import { makeAutoObservable } from 'mobx';
import * as Sentry from '@sentry/react';

export class MapStore {
  selectedZipCodeList = {};
  audienceAverageAge = 0;
  audienceAverageIncome = 0;
  maleAudiencePercent = 0.0;
  femaleAudiencePercent = 0.0;
  otherAudiencePercent = 0.0;
  zipCodeCount = 0;
  totalAddresses = 0;
  rate = 0; //cost of one postcard
  price = 0;
  totalDiscount = 0;
  totalCostWithoutDiscount = 0;
  totalCost = 0;
  quantityUntilNextDiscount = 0;

  constructor() {
    makeAutoObservable(this);
  }

  initalizeMapStore() {
    this.selectedZipCodeList = {};
    this.audienceAverageAge = 0;
    this.audienceAverageIncome = 0;
    this.maleAudiencePercent = 0.0;
    this.femaleAudiencePercent = 0.0;
    this.otherAudiencePercent = 0.0;
    this.zipCodeCount = 0;
    this.rate = 0;
    this.price = 0;
    this.totalAddresses = 0;
    this.totalDiscount = 0;
    this.totalCostWithoutDiscount = 0;
    this.totalCost = 0;
    this.quantityUntilNextDiscount = 0;
  }

  updateData(quote, zipcodes) {
    try {
      this.setSelectedZipCodeList(zipcodes);
      this.setMaleAudiencePercent(quote.demographics.gender_male);
      this.setFemaleAudiencePercent(quote.demographics.gender_female);
      this.setFemaleAudiencePercent(quote.demographics.gender_other);
      this.setTotalAddresses(quote.demographics.total_households);
      this.setAverageAge(quote.demographics.avg_age);
      this.setAverageIncome(quote.demographics.avg_hhi_formatted);
      this.setZipCodeCount(quote.total_zipcodes);
      this.setRate(quote.rate);
      this.setPrice(quote.price);
      this.setTotalCostWithoutDiscount(quote.price_without_discount_formatted);
      this.setTotalDiscount(quote.total_discount_formatted);
      this.setTotalCost(quote.price_formatted);
      this.setQuantityUntilNextDiscount(quote.qty_next_discount_formatted);
    } catch (error) {
      Sentry.captureException(new Error('Error in mapStore: ' + error));
    }
  }

  addZipCode(value) {
    if (!this.selectedZipCodeList.some((el) => el.id === value.id)) {
      this.selectedZipCodeList.push(value);
    }
  }

  setSelectedZipCodeList(zipcodes) {
    this.selectedZipCodeList = zipcodes;
  }

  setMaleAudiencePercent(value) {
    this.maleAudiencePercent = value;
  }

  setFemaleAudiencePercent(value) {
    this.femaleAudiencePercent = value;
  }

  setOtherAudiencePercent(value) {
    this.otherAudiencePercent = value;
  }

  setZipCodeCount(value) {
    this.zipCodeCount = value;
  }

  setAverageAge(value) {
    this.audienceAverageAge = value;
  }

  setAverageIncome(value) {
    this.audienceAverageIncome = value;
  }

  setTotalAddresses(value) {
    this.totalAddresses = value;
  }

  setRate(value) {
    this.rate = value.toFixed(2);
  }

  setPrice(value) {
    this.price = value.toFixed(2);
  }

  setTotalCostWithoutDiscount(value) {
    this.totalCostWithoutDiscount = value;
  }

  setTotalDiscount(value) {
    this.totalDiscount = value;
  }

  setTotalCost(value) {
    this.totalCost = value;
  }

  setQuantityUntilNextDiscount(value) {
    this.quantityUntilNextDiscount = value;
  }
}
